import React, { FC, useEffect, useState } from 'react'

import { ScheduleByDayItem } from '../../../common/ScheduleByDayItem/ScheduleByDayItem'

import { sortScheduling } from '../../../../../helpers/time'
import { getAllRegistrationFees } from '../../../../../helpers/registrationFees'
import { getGroupScheduleByDay } from '../../../../../helpers/schedule'

import { RegistrationFeesType } from '../../../../../models/event-fees/event-fees.interface'
import {
  IEventScheduleInterface,
  TCustomSchedule,
} from '../../../../../models/event-scheduling/event-scheduling.interface'

interface ScheduleByDayProps {
  scheduleBy?: 'class' | 'rider'
  registrationFees?: RegistrationFeesType[] | null
  customScheduling?: IEventScheduleInterface['custom'] | null
}
export const ScheduleByDay: FC<ScheduleByDayProps> = ({
  registrationFees,
  customScheduling,
  scheduleBy,
}) => {
  const [schedules, setSchedules] = useState<{ [key: string]: TCustomSchedule[] }>({})

  useEffect(() => {
    if (registrationFees) {
      const flattenedFees = getAllRegistrationFees(registrationFees)
      const sortedSchedules = sortScheduling([...flattenedFees, ...(customScheduling ?? [])])
      const groupScheduleByDay = getGroupScheduleByDay(sortedSchedules)
      setSchedules(groupScheduleByDay)
    }
  }, [customScheduling, registrationFees])

  return Object.keys(schedules)?.length > 0 ? (
    <>
      {Object.keys(schedules).map((schedule, index) => (
        <ScheduleByDayItem
          schedules={schedules}
          schedule={schedule}
          key={index}
          scheduleBy={scheduleBy}
        />
      ))}
    </>
  ) : (
    <div className="flex justify-center fs-5 text-SeabiscuitDark200ThemeColor">
      Please add required notes for each schedules...
    </div>
  )
}
